module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_03-26a97b7f3e1881d4a1f7e00789a1235c.jpg";